import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card card-flush w-100" }
const _hoisted_2 = { class: "card-header p-5 w-100" }
const _hoisted_3 = {
  key: 0,
  class: "card-title d-flex flex-column w-100"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-up fs-3 text-success me-2" }, null, -1)
const _hoisted_5 = { class: "fs-2 fw-bold d-flex" }
const _hoisted_6 = { class: "ms-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 pt-1 fw-semibold fs-6" }, "Estimated unpaid earnings", -1)
const _hoisted_8 = { class: "d-flex flex-column mt-3 content-justify-center flex-row-fluid" }
const _hoisted_9 = { class: "d-flex fw-semibold align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "bullet w-8px h-3px rounded-2 bg-success me-3" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 flex-grow-1 me-4" }, " Approved applications ", -1)
const _hoisted_12 = { class: "fw-bolder text-gray-700 text-xxl-end" }
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center min-w-100 min-h-150px"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "spinner-border spinner-border-sm" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_count_up = _resolveComponent("count-up")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.earnings.totals, (value, currency) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex align-items-center w-100",
                key: currency
              }, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_count_up, {
                    "end-val": parseFloat(value)
                  }, null, 8, ["end-val"]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(currency), 1)
                ])
              ]))
            }), 128)),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_count_up, {
                    "end-val": _ctx.earnings.count
                  }, null, 8, ["end-val"])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
    ])
  ], 512)), [
    [_vShow, _ctx.earnings.totals.length != 0 || _ctx.loading]
  ])
}